import React from "react";
import { conectData } from "../utils/data";
import MainContainer from "../components/common/Container";
import { Box, Button, Card, Stack, useTheme } from "@mui/material";
import { Link } from "react-router-dom";
const Contact = () => {
  const theme = useTheme();
  return (
    <MainContainer header="CONECT">
      <Stack gap="10px">
        {conectData.map((media) => (
          <Card
            sx={{
              borderRadius:"0",
              position: "relative",
              paddingX: "20px",
              paddingY: "5px",
              "&:hover .decoration ": {
                width: "100%",
                height: "100%",
                position: "absolute",
                left: "0",
                top: "0",
              },
              "&:hover .buttonSkill ": {
                color: "white",
                //
              },
            }}
          >
            <Button
            component={Link}
            to={media.url}
            target="_blank"
              startIcon={media.icon}
              sx={{ color: "inherit", zIndex: 100 }}
              className="buttonSkill"
              fullWidth
            >
              {media.name}
            </Button>

            <Box
              className="decoration"
              sx={{
                width: "10px",
                height: "100%",
                backgroundColor: theme.palette.primary.main,
                position: "absolute",
                left: 0,
                top: 0,
                transition: ".8s",
              }}
            />
          </Card>
        ))}
      </Stack>
    </MainContainer>
  );
};

export default Contact;
